<template>
  <div>
    <v-layout row wrap>
      <v-flex xs6 sm3 d-flex>
        <v-btn
                v-on:click="$emit('create')"
        >
          <v-icon>add</v-icon>
          Add word
        </v-btn>
        <ImportDialog v-if="sourceDictionaryId !== 'en'"></ImportDialog>
      </v-flex>
      <v-flex xs6 sm4 d-flex>
        <v-select
                :items="categories"
                v-model="categoryId"
                item-text="fullName"
                item-value="id"
                placeholder="All categories"
                clearable
                label="Category"
        ></v-select>
      </v-flex>
      <v-flex offset-sm1 xs6 sm4 d-flex>
        <v-text-field
                label="Search"
                append-icon="search"
                v-model="search"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-data-table
            :headers="headers"
            :items="words"
            :loading="isLoading"
            :pagination.sync="pagination"
            :total-items="pagination.totalItems"
            :rows-per-page-items='[25,50,{"text":"All","value":-1}]'
            disable-initial-sort
            class="elevation-1"
    >
      <template slot="items" slot-scope="props">
        <td class="justify-center handle-row"><v-icon>mdi-drag</v-icon></td>
        <td class="text-xs-left">{{ props.item.text }}</td>
        <td class="text-xs-left">{{ props.item.baseWord }}</td>
        <td class="justify-center"><AudioButton v-if="props.item.pronunciation" :src="props.item.pronunciation" /></td>
        <td class="justify-center"><RowImage :src="props.item.imageSet.x1" /></td>
        <td class="justify-center layout px-0">
          <v-icon
                  small
                  class="mr-2"
                  @click="$emit('edit', props.item)"
          >
            edit
          </v-icon>
        </td>
      </template>
      <template slot="no-data">
        <v-alert :value="errorOnLoad" color="error">
          Произошла ошибка при получении данных :(
        </v-alert>
        <div v-if="!errorOnLoad">No data</div>
      </template>
    </v-data-table>
  </div>

</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { FETCH_SOURCE_WORDS, MOVE_WORD } from '../store/action-types'
import debounce from 'lodash/debounce'
import RowImage from './RowImage'
import AudioButton from './AudioButton'
import Sortable from 'sortablejs'
import ImportDialog from './ImportDialog'

export default {
  components: { ImportDialog, AudioButton, RowImage },
  data () {
    return {
      categoryId: null,
      search: null,
      pagination: { page: 1 },

      headers: [
        { text: '', align: 'left', sortable: false },
        { text: 'Word', value: 'text', sortable: false },
        { text: 'Base word', value: 'baseWord', sortable: false },
        { text: 'Pronunc.', value: 'pronunciation', sortable: false },
        { text: 'Image', value: 'image', sortable: false },
        { text: 'Actions', value: 'id', sortable: false }
      ]
    }
  },
  computed: {
    params () {
      return {
        sourceDictionaryId: this.sourceDictionaryId,
        search: this.search,
        categoryId: this.categoryId,
        page: this.pagination.page,
        rowsPerPage: this.pagination.rowsPerPage,
        sortBy: 'position',
        descending: this.pagination.descending
      }
    },
    ...mapState([
      'sourceDictionary',
      'categories',
      'words',
      'errorOnLoad',
      'totalWords'
    ]),
    ...mapGetters([
      'isLoading',
      'sourceDictionaryId'
    ])
  },
  watch: {
    sourceDictionary (cur, prev) {
      if (prev !== null) {
        this.pagination.page = 1
        this.debouncedFetchWords()
      }
    },
    totalWords () {
      this.pagination.totalItems = this.totalWords
    },
    categoryId () {
      this.pagination.page = 1
      this.debouncedFetchWords()
    },
    search () {
      this.pagination.page = 1
      this.debouncedFetchWordsForTyping()
    },
    params: {
      handler () {
        this.debouncedFetchWords()
      },
      deep: true
    },
    isLoading () {
      this.sortable.option('disabled', this.isLoading)
    }
  },
  created () {
    this.debouncedFetchWords = debounce(this.fetchWords, 100)
    this.debouncedFetchWordsForTyping = debounce(this.fetchWords, 800)
    this.debouncedFetchWords()

    this.pagination = {
      page: (this.$route.query.page || 1) * 1,
      rowsPerPage: (this.$route.query.rowsPerPage || 25) * 1,
      sortBy: this.$route.query.sortBy,
      descending: this.$route.query.descending,
      totalItems: (this.$route.query.totalItems || this.totalWords) * 1
    }
    this.categoryId = this.$route.query.categoryId
    this.search = this.$route.query.search
  },
  mounted () {
    let tbody = document.querySelector('.v-datatable tbody')
    this.sortable = Sortable.create(tbody, {
      handle: '.handle-row',
      onEnd: this.changePosition
    })
  },
  destroyed () {
    this.sortable.destroy()
    this.sortable = null
  },
  methods: {
    async fetchWords () {
      await this.$store.dispatch(FETCH_SOURCE_WORDS, { ...this.params })
    },
    async changePosition ({ newIndex, oldIndex }) {
      const element = this.words[oldIndex]
      let position = this.words[newIndex].position

      await this.$store.dispatch(MOVE_WORD, { word: element, position })
    }
  }
}
</script>

<style>
  .handle-row {
    cursor: move !important;
    cursor: -webkit-grabbing !important;
    max-width: 28px;
    width: 28px;
  }
</style>
